/** In-flight cross-campaign moves must not race the 2s save loop. */

const held = new Set();

export function holdSprintSaves(...ids) {
  ids.filter(Boolean).forEach((id) => held.add(id));
}

export function releaseSprintSaves(...ids) {
  ids.filter(Boolean).forEach((id) => held.delete(id));
}

export function isSprintSaveHeld(id) {
  return Boolean(id && held.has(id));
}

/** For tests — do not call from the app. */
export function _resetSprintSaveHolds() {
  held.clear();
}
